export default "__VITE_ASSET__CwClg4pg__"